// @flow
import styled from "styled-components";

export const OverflowHidden = styled.div`
	overflow: hidden;
`;

export default OverflowHidden;